var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.836527 0C0.372951 0 0 0.417969 0 0.9375C0 1.45703 0.372951 1.875 0.836527 1.875H2.65249L4.75426 14.2383C4.83094 14.6797 5.17601 15 5.57685 15H17.0094C17.473 15 17.8459 14.582 17.8459 14.0625C17.8459 13.543 17.473 13.125 17.0094 13.125H6.27046L5.95328 11.25H17.0024C17.5008 11.25 17.94 10.8789 18.0759 10.3398L19.9581 2.83984C20.1568 2.04297 19.6235 1.25 18.8846 1.25H4.25234L4.16869 0.761719C4.09201 0.320313 3.74694 0 3.34611 0H0.836527ZM6.13453 20C7.05819 20 7.80758 19.1602 7.80758 18.125C7.80758 17.0898 7.05819 16.25 6.13453 16.25C5.21086 16.25 4.46148 17.0898 4.46148 18.125C4.46148 19.1602 5.21086 20 6.13453 20ZM17.8459 18.125C17.8459 17.0898 17.0965 16.25 16.1729 16.25C15.2492 16.25 14.4998 17.0898 14.4998 18.125C14.4998 19.1602 15.2492 20 16.1729 20C17.0965 20 17.8459 19.1602 17.8459 18.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartWhite);
export default __webpack_public_path__ + "static/media/Cart-white.eefe7ab2c0963b0642e3b05b147dada6.svg";
export { ForwardRef as ReactComponent };